<template>
  <div>
    <div class="d-start-start mb-3 mt-4">
      <left-text leftText="营业执照"/>
      <upload-image  :existImgs="priceArrs.certpic" :maxLength="1"/>
    </div>
      <div class="d-start-start mb-3 mt-4">
        <left-text leftText="消防验收合格证"/>
        <span v-if="!priceArrs.certfire">未上传</span>
        <upload-image  :existImgs="priceArrs.certfire" :maxLength="1"/>
      </div>
      <div class="d-start-start mb-3 mt-4">
        <left-text leftText="卫生许可证"/>
        <span v-if="!priceArrs.certheal">未上传</span>
        <upload-image  :existImgs="priceArrs.certheal" :maxLength="1"/>
      </div>
      <div class="d-start-start mb-3 mt-4">
        <left-text leftText="特种行业许可证"/>
        <span v-if="!priceArrs.certspec">未上传</span>
        <upload-image  :existImgs="priceArrs.certspec" :maxLength="1"/>
      </div>
    
  </div>
</template>

<script>
export default {
  props:['priceArrs'],
  methods: {
    pcd(){
      return  this.priceArrs.province_name + '省、' + this.priceArrs.city_name + '市、' + this.priceArrs.district_name||'暂无'
    },
  },
}
</script>

<style scoped>
.images-box{
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
</style>